/**
 * Page size for customers table
 */
export const CUSTOMERS_PAGE_SIZE = 10;

/**
 * Empty state messages
 */
export const EMPTY_STATE = {
    NO_CUSTOMERS: {
        HEADER: 'No Customers Yet',
        SUBHEADER: 'Customers will appear here once they make a purchase or sign up',
    },
    NO_MATCH: {
        HEADER: 'No Customers Match Filters',
        SUBHEADER: "Update filters to find what you're looking for!",
    },
} as const;

/**
 * Modal types for customer actions
 */
export const MODAL_TYPES = {
    ADD_TAG: 'addTag',
    REMOVE_TAG: 'removeTag',
    GRANT_PRODUCT: 'grantProduct',
    GRANT_AFFILIATE: 'grantAffiliate',
    ADD_TO_FLOW: 'addToFlow',
    DELETE_CUSTOMERS: 'deleteCustomers',
    EXPORT_CSV: 'exportCsv',
} as const;

export type ModalType = (typeof MODAL_TYPES)[keyof typeof MODAL_TYPES] | null;
